import styled, { css } from 'styled-components';
import {
    space,
    layout,
    typography,
    color,
    border,
    position,
    SpaceProps,
    LayoutProps,
    TypographyProps,
    ColorProps,
    BorderProps,
    PositionProps,
} from 'styled-system';

export const StyledAccordion = styled.div`
    display: block;
`;

type SectionSS = SpaceProps & LayoutProps & TypographyProps & ColorProps & BorderProps & PositionProps;

export const AccordionSectionRoot = styled.div<SectionSS>`
    background-color: ${({ theme }) => theme.colors.accordion.background};
    border: 1px solid ${({ theme }) => theme.colors.accordion.border};
    border-radius: 4px;
    margin-bottom: 20px;

    ${space}
    ${layout}
  ${typography}
  ${color}
  ${border}
  ${position}
`;

export const AccordionHeader = styled.div`
    position: relative;
    padding: 20px 60px 20px 20px;
    cursor: pointer;
`;

export const AccordionTitle = styled.h4`
    font-size: 16px;
    margin: 0;
    text-align: left;
`;

export const ToggleIcon = styled.div`
    position: absolute;
    top: 17px;
    right: 17px;
    padding: 0;
    color: ${({ theme }) => theme.colors.button.primary.text};
    background-color: ${({ theme }) => theme.colors.button.primary.background};
    border: 2px solid ${({ theme }) => theme.colors.button.primary.border};
    width: 25px;
    height: 25px;
    cursor: pointer;
    outline: none;
    appearance: none;
    border-radius: 50%;

    &:hover,
    &:active,
    &:focus {
        outline: none;
        border-style: solid;
    }

    &:focus {
        box-shadow: 0 0 0 0.2rem
            ${({ theme }) => css`
      rgba(${parseInt(theme.colors.button.primary.background.slice(1, 3), 16)}, 
           ${parseInt(theme.colors.button.primary.background.slice(3, 5), 16)},
           ${parseInt(theme.colors.button.primary.background.slice(5, 7), 16)}, 0.25)
    `};
    }
`;

export const IconLine = styled.span<{ $open?: boolean }>`
    transition: all 250ms ease-in-out;
    display: block;
    position: absolute;
    background-color: ${({ theme }) => theme.colors.button.primary.text};
    height: 1px;
    width: 11px;
    top: 10px;
    left: 5px;

    &:nth-child(2) {
        transform: rotate(-90deg);
        ${({ $open }) =>
            $open &&
            css`
                transform: rotate(0deg);
            `}
    }
`;

export const AccordionContent = styled.div<{ $open?: boolean; $maxHeight?: string | number }>`
    max-height: ${({ $maxHeight }) => $maxHeight};
    opacity: ${({ $open }) => ($open ? 1 : 0)};
    overflow: hidden;
    text-align: left;
    transition:
        max-height 250ms ease-in-out,
        opacity 500ms linear;
    height: auto;
`;

export const AccordionContentInner = styled.div`
    padding: 0 20px 20px 20px;
`;
